export default {
    set(state, { data }) {
      state.syncs = data;
    },
    show(state, { data }) {
      state.sync = data;
    },
    getPage(state, { data }) {
      state.page = data
    }
  }